import script from "./clear-forecast-confirm-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./clear-forecast-confirm-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__